import { useMemo, useState } from 'react'
import { Button, KIND, SIZE, SHAPE } from "baseui/button";
// api
import { useNotAckedAlarms } from '../../hooks/useNotAckedAlarms'
import { useAckAllAlarmsMutation } from '../../services/alarm'
import { useIntl, FormattedMessage } from 'react-intl';
import { useStyletron } from 'baseui';
import { VscCheckAll } from 'react-icons/vsc';

export interface AckAllButtonProps {
    onClick: any,
    disabled: boolean
    loading: boolean
}

export const AckAllButton = (props: AckAllButtonProps) => {
    const [css, theme] = useStyletron();
    const intl = useIntl();

    return (
        <Button title={intl.formatMessage({ id: "alarms.ackAllAlarms", defaultMessage: "Acknowledge All" })} className={css({ boxShadow: theme.lighting.shadow500 })} {...props} shape={SHAPE.pill} isLoading={props.loading} >
            <VscCheckAll></VscCheckAll>
        </Button>
    )
}


export const StatefulAckAllButton = () => {
    const [ackAll, result] = useAckAllAlarmsMutation();
    const { count, error, isLoading } = useNotAckedAlarms()


    const disableAckAll = count === 0;

    return (
        <AckAllButton loading={result.isLoading} disabled={disableAckAll} onClick={() => ackAll()} />
    )
}